import { Box, Card, Divider, Grid, Group, Stack, Text, Title } from '@mantine/core';
import { IconHeart } from '@tabler/icons-react';
import prettifiedLabel from '../../constants/labelPrettifier';

const ActivateDomainSubscriptionCard = ({ subscription, isSelected, toggleSelected }) => {
  return (
    <Grid.Col span={{ base: 12, sm: 6, lg: 3 }}>
      <Card
        withBorder
        className={`subscription-card ${isSelected ? 'subscription-card-selected' : ''}`}
        onClick={() => toggleSelected(subscription)}
        padding="md"
        style={{ cursor: 'pointer', height: '100%' }}
      >
        <Stack gap="sm" style={{ height: '100%' }}>
          <Title order={3} fw={700}>
            {subscription.name.toUpperCase()}
          </Title>
          <Title order={6}>{subscription.summary}</Title>
          <Text size="xs">{subscription.description}</Text>
          <div>
            {subscription.subscriptionTieredPricings.length > 0 && (
              <>
                <Divider my="xs" />
                <Title order={6}>
                  <strong>
                    {parseFloat(subscription.subscriptionTieredPricings[0].price).toLocaleString('en-US', {
                      style: 'currency',
                      currency: subscription.currency,
                    })}
                  </strong>{' '}
                  {subscription.subscriptionTieredPricings[0].treshold > 0 && (
                    <>
                      (up to {parseInt(subscription.subscriptionTieredPricings[0].treshold).toLocaleString('en-US')}{' '}
                      {subscription.subscriptionTieredPricings[0].unit})
                    </>
                  )}{' '}
                  / month
                </Title>
                <Text c="dimmed" size="sm">
                  {subscription.subscriptionTieredPricings.slice(1).length > 0 && (
                    <>
                      {subscription.subscriptionTieredPricings.slice(1).map((pricing, index) => {
                        return (
                          <div key={index}>
                            {parseFloat(pricing.price).toLocaleString('en-US', {
                              style: 'currency',
                              currency: subscription.currency,
                            })}{' '}
                            /month @ {parseInt(pricing.treshold).toLocaleString('en-US')} {pricing.unit}+
                          </div>
                        );
                      })}
                    </>
                  )}
                </Text>
                {subscription.subscriptionDynamicPricings.length > 0 && (
                  <>
                    <Divider my="sm" />
                    <Text size="sm" fw={700}> + Usage:</Text>
                  </>
                )}
              </>
            )}
            {subscription.subscriptionDynamicPricings.map((pricing, index) => {
              return (
                <Text size="sm" key={index}>
                  {' '}
                  {parseFloat(pricing.unitPrice).toLocaleString('en-US', {
                    style: 'currency',
                    currency: subscription.currency,
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 5,
                  })}{' '}
                  / {prettifiedLabel(pricing.unit.slice(0, -1))}
                </Text>
              );
            })}
          </div>
          <Box mt="auto">
            <Divider my="xs" />
            <Group justify="space-between">
              <Text c="dimmed">Billed monthly</Text>
              <Text c="dimmed">
                <IconHeart size={16} style={{ verticalAlign: 'middle' }} /> {subscription.type === 'flagship' ? 30 : 10}
                -day free trial
              </Text>
            </Group>
          </Box>
        </Stack>
      </Card>
    </Grid.Col>
  );
};

export default ActivateDomainSubscriptionCard;
